export type InlineArrayResult<T> = [T | null, Error | null]

export const inlinePromise = async <T>(promise: Promise<T | any>): Promise<InlineArrayResult<T>> => {
    return new Promise<InlineArrayResult<T>>(resolve =>
        promise
            .then((data) => resolve([data as T, null]))
            .catch((err) => resolve([null as T, err]))
    )
}